import axios from "../axios";


/**
 * 保存
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const save = (data) => {
  return axios({
    url: "/mZyjnSkillLevel/save",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

/**
 * 获取技能等级实施计划列表
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const getList = (data) => {
  return axios({
    url: "/mZyjnSkillLevel/getList",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const getInfoById = (data) => {
  return axios({
    url: "/mZyjnSkillLevel/view",
    method: 'post',
    data
  })
}

export const downloadApplication = (data) => {
  return axios({
    url: '/mZyjnSkillLevel/downloadApplication',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}
let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}

export const exportSsjhbab = (name, data) => {
  return axios({
    url: "/mZyjnSkillLevel/exportSsjhbab",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/mZyjnSkillLevel.js